// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ovY1","importantInfo":"styles_importantInfo__Kk-_C"};